import { validationHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'

export function validate(values) {
    const errors = {}

    if (validationHelper.stringIsNullOrEmpty(values.minStock)) {
        errors.minStock = messages.MANDATORY_FIELD
    }
    else if (validationHelper.isPositive(values.minStock)) {
        errors.name = messages.NUMBER_FORMAT_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.store_id) || values.store_id == '0') {
        errors.store_id = messages.MANDATORY_FIELD
    }

    if (!values.reception_date) {
        errors.reception_date = messages.MANDATORY_FIELD
    }

    return errors
}


// WEBPACK FOOTER //
// ./src/scenes/Administration/Product/ProductDetail/_validate.js